import { useQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { pendingOperationsSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

export const pendingOperationsParams = {
  queryKey: [API_ENDPOINTS.PENDING_OPERATIONS],
  queryFn: () => get(API_ENDPOINTS.PENDING_OPERATIONS, pendingOperationsSchema),
}

export const useAPIGetPendingOperations = () =>
  useQuery(pendingOperationsParams)
